import React, { useContext } from 'react';
import { Result, Button } from 'antd';
import { Context } from '../../../defaults';

const SessionExpired = () => {
    const { dictionary, language } = useContext(Context);
    return (
        <Result
            status="warning"
            title={`${dictionary?.SessionExpired[language]}`}
            extra={
                <Button
                    type='primary'
                    onClick={
                        () => {
                            window.location.href = '/login';
                        }
                    }
                >
                    {dictionary?.LogIn[language]}
                </Button>
            }
        />
    );
}

export default SessionExpired;